module.exports = __webpack_public_path__ + "img/changePassword.838992c4.png";